import React from 'react';
import styles from './button.module.css';
import Icon from "../../icons/icons";

const ButtonLink = props => {
  return (
      <a href={props.url} rel="noopener noreferrer" className={styles.button_link} target="_blank">
        <Icon name={props.icon} viewbox="0 0 24 24" />
        {props.text}
      </a>
  )
}

export default ButtonLink;